import { BaseComponent2 } from '../../_common/client/base-component2';

export class SdaComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_sda__slot';

    constructor() {
        super();
    }

    public async init(): Promise<void> {}

    public async onReloadComponentEvent(): Promise<void> {
        o_global.eventQBus.emitRetain('as.odin.sda.initialize', {
            slotIdentifier: this.getSdaSlotId(),
            isVariationChange: !!o_product?.state?.isVariationChanged,
            eventMergeId: o_product.tracking.eventMergeId,
        });
    }

    private getSdaSlotId() {
        return this.getRootElement().dataset.sdaSlotId;
    }
}
